import { bemGenerator } from '@prisjakt/ui-base';
import './index.scss';

export default bemGenerator('pj-ui-icon', [
  'stock',
  'check',
  'in-stock',
  'incoming',
  'out-of-stock',
  'stock-unknown',
  'star',
]);
